<template>
  <signup :title="promotionDetails.title"
          :sub-title="'ליצירת החשבון נצטרך כמה פרטים:'"
          :button-title="'אני רוצה להירשם'"
          :button-action="generateCodeAndProceed"
          :error="serverErrors.generateCode"
          :reset-error="() => resetError('generateCode')">
    <template v-slot:header>
      <img class="promotion-header" :src="require(`@/assets/${promotionDetails.header}`)"/>
    </template>
    <template v-slot:information-details>
      <information-details :title="promotionDetails.detailsTitle"
                           :details="promotionDetails.details"/>
    </template>
  </signup>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import Signup from '@/base-components/Signup';
import InformationDetails
  from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/InformationDetails';
import Segment from '../../../../../../Segment';
import promotionConsts from '../../../../../../constants/promotions';

export default {
  name: 'IntroductionWithPromo',
  components: {
    InformationDetails,
    Signup,
  },
  data() {
    return {
      PROMOTION_DETAILS: {
        [promotionConsts.PROMOTION_NAMES.BAT_YAM]: {
          header: 'promotions/bat-yam/batyam-header.svg',
          title: 'תושבי בת-ים, מצטרפים לשירות ונהנים מחודש נוסף במנוי מתנה!',
          detailsTitle: 'עוד על ההטבה לתושבי בת-ים:',
          details: [
            'חודש ראשון נסיון חינם',
            'נרשמים למנוי בתשלום ב-₪45',
            'נהנים מחודש נוסף מתנת עירית בת-ים',
            'לא צריך להכניס פרטי אשראי עד לסוף תקופת הנסיון',
            'בלי התחייבות ואפשר לבטל בכל שלב',
          ],
        },
        [promotionConsts.PROMOTION_NAMES.NEVO_FIRST_MONTH_FREE]: {
          header: 'promotions/nevo/nevo_header.svg',
          title: 'משתתפי הקורס נהנים מחודשיים ראשונים בשירות חינם!',
          detailsTitle: 'הטבה למשתתפי הקורס rising up together:',
          details: [
            'חודש ראשון נסיון חינם',
            'חודש נוסף במנוי ללא תשלום',
            'משלמים רק מהחודש השלישי לשימוש, ₪45 לחודש',
            'לא צריך להכניס פרטי אשראי עד לסוף תקופת הנסיון',
            'בלי התחייבות ואפשר לבטל בכל שלב',
          ],
        },
        [promotionConsts.PROMOTION_NAMES.NEW_CREDIT_TWO_MONTHS_FREE]: {
          header: 'promotions/new-credit/newcredit_header.svg',
          title: 'לקוחות NewCredit נהנים מחודשיים ראשונים בשירות חינם!',
          detailsTitle: 'הטבה ללקוחות NewCredit:',
          details: [
            'חודש ראשון נסיון חינם',
            'חודשיים נוספים במנוי ללא תשלום',
            'משלמים רק מהחודש הרביעי לשימוש, ₪45 לחודש',
            'לא צריך להכניס פרטי אשראי עד לסוף תקופת הנסיון',
            'בלי התחייבות ואפשר לבטל בכל שלב',
          ],
        },
      },
    };
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('RegistrationEntered', { promotion: this.promotion });
    Segment.trackUserGotToPixel('RE');
  },
  computed: {
    ...mapState('signup', ['phoneNumber', 'firstName', 'lastName', 'serverErrors', 'email', 'enableMarketingEmails']),
    ...mapState('promotions', ['promotion']),
    promotionDetails() {
      return this.PROMOTION_DETAILS[this.promotion];
    },
  },
  methods: {
    ...mapActions('signup', ['generateCode']),
    ...mapMutations('signup', ['setFirstName', 'setLastName', 'setPhoneNumber', 'resetError', 'setEmail', 'setEnableMarketingEmails']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      await this.setEmail(email);
      await this.setEnableMarketingEmails(enableMarketingEmails);
      Segment.trackUserInteraction('GenerateCodeClicked', {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
        isMarketingConsent: this.enableMarketingEmails,
      });
      await this.generateCode();
      this.next();
    },
    goToLogin() {
      window.location.href = '/sr';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';
.promotion-header {
  width: 100%;
}

</style>
